import { useState, useEffect } from "react";
import { X, MessageSquare } from "lucide-react";

// Componente de notificación de nuevo mensaje
export const NewMessagePopup = ({ 
  message, 
  senderName, 
  senderPicture,
  onOpen, 
  onDismiss,
  autoHideMs = 5000 
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isLeaving, setIsLeaving] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleDismiss();
    }, autoHideMs);

    return () => clearTimeout(timer);
  }, [autoHideMs]);

  const handleDismiss = () => {
    setIsLeaving(true);
    setTimeout(() => {
      setIsVisible(false);
      onDismiss?.();
    }, 300);
  };

  const handleOpen = () => {
    handleDismiss();
    onOpen?.();
  };

  if (!isVisible) return null;

  return (
    <div 
      className={`fixed top-4 left-1/2 -translate-x-1/2 z-[9999] w-[90vw] max-w-sm transition-all duration-300 ${
        isLeaving ? 'opacity-0 -translate-y-4' : 'opacity-100 translate-y-0'
      }`}
    >
      <div 
        onClick={handleOpen}
        className="bg-[#232e3c] border border-slate-600 rounded-2xl shadow-2xl shadow-black/50 p-4 cursor-pointer hover:bg-[#2a3848] transition-colors"
      >
        <div className="flex items-start gap-3">
          {/* Avatar */}
          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-red-500 to-purple-600 flex items-center justify-center flex-shrink-0 overflow-hidden">
            {senderPicture ? (
              <img src={senderPicture} alt="" className="w-full h-full object-cover" />
            ) : (
              <span className="text-white text-lg font-bold">
                {senderName?.charAt(0).toUpperCase() || "?"}
              </span>
            )}
          </div>
          
          {/* Content */}
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-1">
              <MessageSquare className="w-4 h-4 text-red-400" />
              <span className="text-red-400 text-xs font-medium">Nuevo mensaje</span>
            </div>
            <p className="text-white font-semibold text-base truncate">
              {senderName || "Usuario"}
            </p>
            <p className="text-slate-400 text-sm truncate mt-0.5">
              {message || "Te envió un mensaje"}
            </p>
          </div>

          {/* Close button */}
          <button 
            onClick={(e) => {
              e.stopPropagation();
              handleDismiss();
            }}
            className="text-slate-500 hover:text-white transition-colors p-1"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Tap to open indicator */}
        <div className="mt-3 pt-3 border-t border-slate-700">
          <p className="text-center text-slate-500 text-xs">
            Toca para abrir la conversación
          </p>
        </div>
      </div>
    </div>
  );
};

export default NewMessagePopup;
